@if (reviewSchema(); as schema) {
  <app-json-ld [json]="schema"></app-json-ld>
}

@let reviewList = reviews();

<div class="review-summary d-flex align-items-center">
  <span class="review-stars review-stars--lg" [attr.aria-label]="averageRating() + ' out of 5 stars'">
    @for (star of stars; track star) {
      <span class="review-star" [class.is-filled]="star <= averageRatingRounded()">★</span>
    }
  </span>
  <span class="text-secondary ms-1 fw-semi">
    {{ 'product-reviews-gemiddelde' | fromDictionary | setValueDict: [{ key: 'rating', value: `${averageRatingRounded()}` }] }}
  </span>
</div>

<ul class="review-list">
  @for (review of reviewList; track review.uuid) {
    <li class="review-list-item">
      <article class="review">
        @let avatarUrl =
          review.avatar_image_url || (review.gravatar_hash ? 'https://www.gravatar.com/avatar/' + review.gravatar_hash : null);
        <header class="review-header">
          @if (avatarUrl) {
            <img class="review-icon review-icon--image" [src]="avatarUrl" alt="" loading="lazy" />
          } @else {
            <span class="review-icon">{{ review.reviewer_initial }}</span>
          }
          <span class="review-stars" [attr.aria-label]="review.rating + ' out of 5 stars'">
            @for (star of stars; track star) {
              <span class="review-star" [class.is-filled]="star <= review.rating">★</span>
            }
          </span>
          @if (review.verified_buyer) {
            <span class="review-badge">{{ 'product-reviews-verified' | fromDictionary }}</span>
          }
          <div class="review-author-wrapper">
            <span class="review-author">{{ review.reviewer_name }}</span>
            <span class="review-date">{{ review.created_at | date: 'd MMM y' }}</span>
            @if (review.source === 'shop_app') {
              <span class="review-source">{{ 'product-reviews-via-shop' | fromDictionary }}</span>
            }
          </div>
        </header>
        <div class="review-content">
          @if (review.title) {
            <strong class="review-title">{{ review.title }}</strong>
          }
          <p appOverflowDetector #overflow="overflowDetector" class="review-body" [class.is-clamped]="!isExpanded(review.uuid)">
            {{ review.body }}
          </p>
          @if (overflow.isOverflowing()) {
            <button type="button" class="link review-readmore" (click)="toggleExpanded(review.uuid)">
              {{
                isExpanded(review.uuid)
                  ? ('product-reviews-verberg-meer' | fromDictionary)
                  : ('product-reviews-toon-meer' | fromDictionary)
              }}
            </button>
          }
          @if (review.pictures_urls.length) {
            <div class="review-media">
              @for (picture of review.pictures_urls; track picture.small) {
                <a [href]="picture.original" target="_blank" rel="noopener noreferrer">
                  <img class="review-media-item" [src]="picture.small" alt="review image {{ $index }}" loading="lazy" />
                </a>
              }
            </div>
          }
        </div>
      </article>
    </li>
  }
</ul>
